export enum AssetClass {
  FIX,
  FI,
}

export namespace AssetClass {
  let elements = [AssetClass.FIX, AssetClass.FI];
  let alias = "com.bcdfx.model.AssetClass";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
